module.exports = __webpack_public_path__ + "img/more-vertical.e680a802.svg";